import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { Props } from 'components/GeneralFormView/types';
import {
  convertFromRaw, EditorState,
} from 'draft-js';
import {
  Form, Formik,
} from 'formik';
import React, {
  Component,
} from 'react';
import {
  Prompt,
} from 'react-router';
import {
  ObjectSchema,
} from 'yup';
import Directives from '../../Directives/Directives';
import AutoScheduledField from '../FormFields/AutoScheduledField/AutoScheduledField';
import ColorPickerField from '../FormFields/ColorPickerField/ColorPickerField';
import DatePickerField from '../FormFields/DatePickerField/DatePickerField';
import DropdownField from '../FormFields/DropdownField/DropdownField';
import {
  FormField, IAutoScheduledField, IColorPickerField, IDatePickerField, IDropdownField, IGalleryField, IGoogleMapField, IInputField, IMultipleSelectField, IRichTextField, ISearchSelectField, IToggleButtonField,
} from '../FormFields/formFields';
import GalleryField from '../FormFields/GalleryField/GalleryField';
import GoogleMapField from '../FormFields/GoogleMapField/GoogleMapField';
import InputField from '../FormFields/InputField/InputField';
import MultipleSelectField from '../FormFields/multipleSelectField/multipleSelectField';
import RichTextField from '../FormFields/RichTextField/RichTextField';
import SearchSelectField from '../FormFields/SearchSelectField/searchSelectField';
import ToggleButtonField from '../FormFields/ToggleButtonField/ToggleButtonField';
import classes from './GeneralFormComponent.module.scss';

interface IProps {
  formTitle: string;
  fields: FormField[];
  formSchema: ObjectSchema<any>;
  onChangeValues?: (key: any, value: any) => void;
  submitButton?: {
    title: string;
    onSubmit(values: any): void;
  };
  cancelButton?: {
    title: string;
    onCancel(): void;
  };
  dropdownLanguages?: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null;
  processing: boolean;
}

class GeneralFormComponent extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.updateInputFields = this.updateInputFields.bind(this)
    this.state = this.updateInputFields(this.props.fields);
  }

  componentWillReceiveProps(nextProps: IProps) {
    if (!nextProps.onChangeValues && !nextProps.processing) {
      const fields = nextProps.fields.map((f) => {
        f.value = f.value || this.state[f.name];
        return f;
      });
      this.state = this.updateInputFields(fields);
    }
  };


  updateInputFields(fields: any []) {
    const constructedState = {
    } as any;
    for (const field of fields) {
      if (field.filedType === 'InputField') {
        constructedState[field.name] = field.value ? field.value : '';
      } else if (field.filedType === 'GalleryField') {
        constructedState[field.name] = field.value ? field.value : [];
      } else if (field.filedType === 'MultipleSelectField') {
        constructedState[field.name] = field.value ? field.value : [];
      } else if (field.filedType === 'RichTextField') {
        const { blocks, entityMap } = field.value || [];

        constructedState[field.name] = EditorState.createWithContent(
          convertFromRaw(
            {
              blocks: blocks || [
                {
                  key: 'initialBlock',
                  text: '',
                  type: 'unstyled',
                  depth: 0,
                  inlineStyleRanges: [],
                  entityRanges: [],
                  data: {}
                }
              ],
              entityMap: entityMap || {}
            }));
      } else if (field.filedType === 'ToggleButtonField') {
        constructedState[field.name] = !!field.value;
      } else if (field.filedType === 'AutoScheduledField') {
        const initValue = field.value || {
        };
        initValue.toggle = !!initValue.toggle;
        constructedState[field.name] = initValue;
      } else {
        constructedState[field.name] = field.value;
      }
    }
    constructedState.formChanged = false;
    return constructedState;
  }

  handleSubmit = (values: any) => {
    console.log(values);
    this.setState({
      formChanged: false,
    });
  };

  handleChange = (prop: any) => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    this.setState({
      [prop]: event.target.value,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, event.target.value);
    }
  };

  handleMarkerChange = (prop: any, value: any) => {
    this.setState({
      [prop]: value,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, value);
    }
  };

  handleMultipleSelectChange = (prop: any) => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    // console.log(prop);
    // console.log(event.target.value);
    this.setState({
      [prop]: event.target.value,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, event.target.value);
    }
  };

  handleDropdownChange = (prop: any) => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    this.setState({
      [prop]: event.target.value,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, event.target.value);
    }
  };

  public handleColorPickerChange = (prop: any, color: string) => {
    this.setState({
      [prop]: color,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, color);
    }
  };

  handleAddImageToGallery = (prop: any, imageFile: File) => {
    const oldGallery = this.state[prop] || [];
    const file = Object.assign(imageFile, {
      preview: URL.createObjectURL(imageFile),
    });
    oldGallery.push(file);
    this.setState({
      [prop]: oldGallery,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, oldGallery);
    }
  };

  handleAddImageToGalleryInCaseOfLimit = (prop: any, imageFile: File) => {
    const file = Object.assign(imageFile, {
      preview: URL.createObjectURL(imageFile),
    });
    this.setState({
      [prop]: [file],
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, [file]);
    }
  };

  handleDeleteImageFromGallery = (prop: any, imageIndex: number) => {
    const oldGallery = this.state[prop] || [];
    oldGallery.splice(imageIndex, 1);
    this.setState({
      [prop]: oldGallery,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, oldGallery);
    }
  };

  handleEditorStateChange = (prop: any, editorState: EditorState) => {
    this.setState({
      [prop]: editorState,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, editorState);
    }
  };

  handleToggleButtonChange = (prop: any, value: boolean) => {
    this.setState({
      [prop]: value,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, value);
    }
  };

  handleDatePickerChange = (prop: any, value: Date) => {
    this.setState({
      [prop]: value,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, value);
    }
  };

  handleAutoScheduledToggleButtonChange = (parentProp: any, prop: any, value: boolean) => {
    const autoState = this.state[parentProp];
    this.setState({
      [parentProp]: {
        ...autoState, [prop]: value,
      },
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, value);
    }
  };

  handleAutoScheduledStartDatePickerChange = (parentProp: any, prop: any, value: Date) => {
    const autoState = this.state[parentProp];
    this.setState({
      [parentProp]: {
        ...autoState, [prop]: value,
      },
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, value);
    }
  };

  handleAutoScheduledEndDatePickerChange = (parentProp: any, prop: any, value: Date) => {
    const autoState = this.state[parentProp];
    this.setState({
      [parentProp]: {
        ...autoState, [prop]: value,
      },
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, value);
    }
  };

  getInputField = (field: IInputField, errors: any, touched: any, index: number): any => (
    <InputField
      onChange={this.handleChange}
      errors={errors}
      touched={touched}
      filedType={field.filedType}
      name={field.name}
      label={field.label}
      type={field.type}
      multiLine={(!!field.multiLine)}
      rowsMax={(field.rowsMax)}
      value={this.state[field.name]}
      suffix={field.suffix}
      disabled={!!field.disabled}
      key={index}
    />
  );

  getGoogleMapField = (field: IGoogleMapField, index: number): any => (
    <GoogleMapField
      onChange={this.handleMarkerChange}
      filedType={field.filedType}
      name={field.name}
      value={this.state[field.name]}
      label={field.label}
      key={index}
    />
  );

  getGalleryField = (field: IGalleryField, errors: any, touched: any, index: number): any => (
    <GalleryField
      onAddImage={field.isLimitToOneImage ? this.handleAddImageToGalleryInCaseOfLimit : this.handleAddImageToGallery}
      onRemoveImage={this.handleDeleteImageFromGallery}
      filedType={field.filedType}
      name={field.name}
      errors={errors}
      touched={touched}
      value={this.state[field.name]}
      accept={field.accept}
      label={field.label}
      isLimitToOneImage={field.isLimitToOneImage}
      textMessage={field.textMessage}
      warningMessage={field.warningMessage}
      key={index}
      ratio={field.ratio}
      size={field.size}
      processing={this.props.processing}
      hideProgressBar={field.hideProgressBar}
    />
  );

  getMultipleSelectField = (field: IMultipleSelectField, errors: any, touched: any, index: number): any => (
    <MultipleSelectField
      onChange={this.handleMultipleSelectChange}
      errors={errors}
      touched={touched}
      filedType={field.filedType}
      name={field.name}
      selectListKey={field.selectListKey}
      selectListValue={field.selectListValue}
      selectList={field.selectList}
      label={field.label}
      value={this.state[field.name]}
      key={index}
    />
  );

  getDropdownField = (field: IDropdownField, errors: any, touched: any, index: number): any => (
    <DropdownField
      onChange={this.handleDropdownChange}
      errors={errors}
      touched={touched}
      filedType={field.filedType}
      name={field.name}
      selectListKey={field.selectListKey}
      selectListValue={field.selectListValue}
      selectList={field.selectList}
      label={field.label}
      value={this.state[field.name] ? this.state[field.name] : field.value}
      key={index}
    />
  );

  getRichTextField = (field: IRichTextField, errors: any, touched: any, index: number): any => (
    <RichTextField
      onChange={this.handleEditorStateChange}
      errors={errors}
      touched={touched}
      filedType={field.filedType}
      name={field.name}
      label={field.label}
      value={this.state[field.name]}
      key={index}
    />
  );

  getToggleButtonField = (field: IToggleButtonField, errors: any, touched: any, index: number): any => (
    <ToggleButtonField
      onChange={this.handleToggleButtonChange}
      errors={errors}
      touched={touched}
      filedType={field.filedType}
      name={field.name}
      label={field.label}
      value={this.state[field.name]}
      activeLabel={field.activeLabel}
      inactiveLabel={field.inactiveLabel}
      key={index}
    />
  );

  getDatePickerField = (field: IDatePickerField, errors: any, touched: any, index: number): any => (
    <DatePickerField
      onChange={this.handleDatePickerChange}
      withTimePicker={field.withTimePicker}
      errors={errors}
      touched={touched}
      filedType={field.filedType}
      name={field.name}
      label={field.label}
      minDate={field.minDate}
      value={this.state[field.name]}
      key={index}
    />
  );

  getAutoScheduledField = (field: IAutoScheduledField, errors: any, touched: any, index: number): any => (
    <AutoScheduledField
      onToggleChange={this.handleAutoScheduledToggleButtonChange}
      onStartDateChange={this.handleAutoScheduledStartDatePickerChange}
      onEndDateChange={this.handleAutoScheduledEndDatePickerChange}
      filedType={field.filedType}
      name={field.name}
      label={field.label}
      errors={errors}
      touched={touched}
      toggle={field.toggle}
      startDate={field.startDate}
      endDate={field.endDate}
      value={this.state[field.name]}
      key={index}
    />
  );

  handleSearchSelectChange = (prop: any, value: any) => {
    this.setState({
      [prop]: value,
    });
    this.setState({
      formChanged: true,
    });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(prop, value);
    }
  };

  getSelectSearchField = (field: ISearchSelectField, errors: any, touched: any, index: number): any => (
    <SearchSelectField
      onChange={this.handleSearchSelectChange}
      errors={errors}
      touched={touched}
      filedType={field.filedType}
      name={field.name}
      selectListKey={field.selectListKey}
      selectListValue={field.selectListValue}
      selectList={field.selectList}
      label={field.label}
      value={this.state[field.name]}
      key={index}
    />
  );

  public getColorPickerField = (field: IColorPickerField, errors: any, touched: any, index: number): any => (
    <ColorPickerField
      onChange={this.handleColorPickerChange}
      errors={errors}
      touched={touched}
      filedType={field.filedType}
      name={field.name}
      color={this.state[field.name]}
      label={field.label}
      value={this.state[field.name]}
      key={index}
    />
  );

  getField = (field: FormField, errors: any, touched: any, index: number): any => {
    if (field.filedType === 'InputField') {
      return this.getInputField(field as IInputField, errors, touched, index);
    }
    if (field.filedType === 'GoogleMapField') {
      return this.getGoogleMapField(field as IGoogleMapField, index);
    }
    if (field.filedType === 'GalleryField') {
      return this.getGalleryField(field as IGalleryField, errors, touched, index);
    }
    if (field.filedType === 'MultipleSelectField') {
      return this.getMultipleSelectField(field as IMultipleSelectField, errors, touched, index);
    }
    if (field.filedType === 'DropdownField') {
      return this.getDropdownField(field as IDropdownField, errors, touched, index);
    }
    if (field.filedType === 'RichTextField') {
      return this.getRichTextField(field as IRichTextField, errors, touched, index);
    }
    if (field.filedType === 'ToggleButtonField') {
      return this.getToggleButtonField(field as IToggleButtonField, errors, touched, index);
    }
    if (field.filedType === 'DatePickerField') {
      return this.getDatePickerField(field as IDatePickerField, errors, touched, index);
    }
    if (field.filedType === 'AutoScheduledField') {
      return this.getAutoScheduledField(field as IAutoScheduledField, errors, touched, index);
    }
    if (field.filedType === 'SearchSelectField') {
      return this.getSelectSearchField(field as ISearchSelectField, errors, touched, index);
    }
    if (field.filedType === 'ColorPickerField') {
      return this.getColorPickerField(field as IColorPickerField, errors, touched, index);
    }

    return '';
  };

  revokeImageGallery(field: any) {
    if (field) {
      field.forEach((image: any) => {
        if (image.preview) {
          URL.revokeObjectURL(image.preview);
        }
      });
    }
  }

  componentWillUnmount() {
    // Make sure to revoke the data uris to avoid memory leaks
    for (const field of this.props.fields) {
      if (field.filedType === 'GalleryField') {
        this.revokeImageGallery(this.state[field.name]);
      }
    }
  }

  handleDropdownLanguageChange = (prop: any) => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    this.props.dropdownLanguages!.onChange(event.target.value);
  };

  getDropdownLanguages = (): any => (
    <DropdownField
      onChange={this.handleDropdownLanguageChange}
      errors={{
      }}
      touched={{
      }}
      filedType="DropdownField"
      name="language"
      selectListKey="langCode"
      selectListValue="langValue"
      selectList={this.props.dropdownLanguages!.langList}
      label={this.props.dropdownLanguages!.label}
      value={this.props.dropdownLanguages!.selectedLang}
    />
  );

  render() {
    const initialValues = {
    } as any;
    for (const field of this.props.fields) {
      initialValues[field.name] = this.state[field.name];
    }
    return (
      <div className={classes.mainCard}>
        {this.props.dropdownLanguages
          ? <div className={classes.languages}>{this.getDropdownLanguages()}</div> : null}
        <Typography variant="subtitle1" gutterBottom className={classNames(classes.title)}>
          {this.props.formTitle}
        </Typography>

        <Prompt
          when={this.state.formChanged}
          message="You have unsaved changes, Are you sure you want to leave this page?"
        />

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={this.props.formSchema}
          onSubmit={(values) => {
            if (this.props.submitButton) {
              this.props.submitButton.onSubmit(values);
            }
            this.handleSubmit(values);
          }}
        >
          {({
            errors, touched,
          }) => (
            <div className={classes.card}>
              <Form className={classes.form}>
                {
                  this.props.fields.map((ele, index) => this.getField(ele, errors, touched, index))
                }
                <div className={classes.actions}>
                  <Directives dIf={this.props.submitButton}>
                    <div className={classes.submitBox}>
                      <Button
                        variant="contained"
                        className={classes.submit}
                        color="primary"
                        disabled={this.props.processing}
                        type="submit"
                      >
                        {this.props.submitButton ? this.props.submitButton.title : ''}
                      </Button>
                      { this.props.processing && <CircularProgress size={24} color="primary" className={classes.buttonProgress} /> }
                    </div>
                  </Directives>
                  <Directives dIf={this.props.cancelButton}>
                    <Button
                      variant="contained"
                      className={classes.cancel}
                      color="primary"
                      onClick={() => this.props.cancelButton!.onCancel()}
                      type="button"
                    >
                      {this.props.cancelButton ? this.props.cancelButton.title : ''}
                    </Button>
                  </Directives>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    );
  }
}

export default GeneralFormComponent;
